import { render } from "./plinkoGame.vue?vue&type=template&id=097627b6&scoped=true"
import script from "./plinkoGame.vue?vue&type=script&lang=js"
export * from "./plinkoGame.vue?vue&type=script&lang=js"

import "./plinkoGame.vue?vue&type=style&index=0&id=097627b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097627b6"]])

export default __exports__